<!--Presents a banner with a solid background and two headers (one large, one small)
    Must contain at least:
    - Quote
    Optionally can contain:
    - Source 
-->

<template>
  <mdb-container>
    <mdb-row class="pt-5">
      <mdb-col>
        <mdb-card class="primary-color z-depth-2">
          <!--Big text for computers.-->
          <mdb-card-body class="d-none d-md-block">
            <h2>
              <mdb-icon class="justify-content-start mr-4" icon="quote-left"></mdb-icon>
              <strong>{{block.value.quote}}</strong>
              <mdb-icon icon="quote-right" class="ml-4"></mdb-icon>
            </h2>
            <h3 v-if="block.value.source" class="pt-2">-- {{block.value.source}}</h3>
          </mdb-card-body>

          <!--Smaller text variant for mobile -->

          <mdb-card-body class="d-block d-md-none">
            <h4>
              <mdb-icon class="justify-content-start mr-4" icon="quote-left"></mdb-icon>
              <strong>{{block.value.quote}}</strong>
              <mdb-icon icon="quote-right" class="ml-4"></mdb-icon>
            </h4>
            <h5 v-if="block.value.source" class="pt-2">-- {{block.value.source}}</h5>  
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbCard,
  mdbCardBody
} from "mdbvue"
export default {
  props: {
    block: Object
  },
  name: "quote_banner",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbCard,
    mdbCardBody
  }
};
</script>